import isPropValid from '@emotion/is-prop-valid';
/**
 * @internal
 */
export const shouldForwardValidProps = {
    shouldForwardProp: isPropValid,
};
/**
 * Filter out properties that should not be forwarded to the DOM
 *
 * @param checkValid Check whether a prop is valid for HTML and SVG elements (based on @emotion/is-prop-valid)
 * @param "propA, propB, ..." provide the names of the properties to filter and not forward onto the DOM
 */
export const shouldNotForwardProps = (checkValid, ...props) => {
    return {
        shouldForwardProp: (prop) => {
            return checkValid
                ? isPropValid(prop) && props.indexOf(prop) === -1
                : props.indexOf(prop) === -1;
        },
    };
};
const themeProps = [
    'fontWeight',
    'fontFamily',
    'color',
    'opacity',
    'fontStyle',
    'fontSize',
    'letterSpacing',
    'spacing',
    'orientation',
    'size',
    'sizes',
];
/**
 * @internal
 */
export const shouldNotForwardThemeProps = {
    shouldForwardProp: (prop) => {
        return isPropValid(prop) && themeProps.indexOf(prop) === -1;
    },
};
